/* global EWG_REPORT_API_URL */

;(function () {
  if (customElements.get('ewg-report-enter')) {
    document.querySelectorAll('ewg-report-enter').forEach(element => {
      const zipInput = element.querySelector('.ewg-report-enter__input')
      const searchButton = element.querySelector('.ewg-report-enter__search-button')
      if (!zipInput || !searchButton || searchButton.dataset.ewgSearchBound === 'true') return

      searchButton.dataset.ewgSearchBound = 'true'
      searchButton.addEventListener('click', () => {
        if (typeof element.handleSearch === 'function') element.handleSearch()
      })
    })
    return
  }

  class EWGReportEnter extends HTMLElement {
    constructor() {
      super()
      this.zipInput = null
      this.inputWrapper = null
      this.searchButton = null
      this.isSearching = false
      this.boundHandlers = {
        onKeyDown: null,
        onInput: null,
        onSearch: null
      }
    }

    connectedCallback() {
      this.initializeElements()
      this.attachEventListeners()
    }

    disconnectedCallback() {
      this.detachEventListeners()
    }

    initializeElements() {
      this.zipInput = this.querySelector('.ewg-report-enter__input')
      this.inputWrapper = this.zipInput?.closest('.ewg-report-enter__input-wrapper')
      this.searchButton = this.querySelector('.ewg-report-enter__search-button')
    }

    attachEventListeners() {
      if (!this.zipInput) return

      this.boundHandlers.onKeyDown = this.handleKeyDown.bind(this)
      this.boundHandlers.onInput = this.handleInput.bind(this)
      this.boundHandlers.onSearch = this.handleSearch.bind(this)

      this.zipInput.addEventListener('keydown', this.boundHandlers.onKeyDown)
      this.zipInput.addEventListener('input', this.boundHandlers.onInput)
      if (this.searchButton) this.searchButton.dataset.ewgSearchBound = 'true'
      this.searchButton?.addEventListener('click', this.boundHandlers.onSearch)
    }

    detachEventListeners() {
      if (!this.zipInput) return

      this.zipInput.removeEventListener('keydown', this.boundHandlers.onKeyDown)
      this.zipInput.removeEventListener('input', this.boundHandlers.onInput)
      this.searchButton?.removeEventListener('click', this.boundHandlers.onSearch)

      this.boundHandlers.onKeyDown = null
      this.boundHandlers.onInput = null
      this.boundHandlers.onSearch = null
    }

    isValidZipCode(value) {
      const zipRegex = /^\d{5}(-\d{4})?$/
      return zipRegex.test(value.trim())
    }

    setZipError(isError) {
      if (this.inputWrapper) this.inputWrapper.classList.toggle('error', isError)
      this.zipInput?.setAttribute('aria-invalid', isError ? 'true' : 'false')
    }

    handleInput() {
      this.setZipError(false)
    }

    handleKeyDown(event) {
      if (event.key !== 'Enter') return

      event.preventDefault()
      this.handleSearch()
    }

    async handleSearch() {
      if (this.isSearching) return

      const value = this.zipInput.value.trim()
      const isValid = this.isValidZipCode(value)

      if (!isValid) {
        this.setZipError(true)
        this.zipInput.focus()
        return
      }

      this.setZipError(false)
      this.isSearching = true
      if (this.searchButton) {
        this.searchButton.disabled = true
        this.searchButton.classList.add('loading')
      }

      let didNavigate = false
      try {
        const response = await fetch(`${EWG_REPORT_API_URL}/zip_systems?zip=${encodeURIComponent(value)}`, {
          method: 'GET'
        })
        const data = response.ok ? await response.json() : null
        const systemList = Array.isArray(data?.systemList) ? data.systemList : []
        const firstProvider = systemList.find(system => system.PWS)

        if (!response.ok || !firstProvider?.PWS) {
          this.setZipError(true)
          this.zipInput.focus()
          return
        }

        const infoResponse = await fetch(
          `${EWG_REPORT_API_URL}/information?pws=${encodeURIComponent(firstProvider.PWS)}`,
          { method: 'GET' }
        )
        const infoData = infoResponse.ok ? await infoResponse.json() : null
        const information = infoData?.information || null

        if (!information) {
          this.setZipError(true)
          this.zipInput.focus()
          return
        }

        window.localStorage.setItem('WD-ewg-zip-code', value)
        sessionStorage.setItem(
          'WD-ewg-zip-systems',
          JSON.stringify({
            zip: value,
            data,
            pws: firstProvider.PWS,
            information,
            timestamp: Date.now()
          })
        )
        this.navigateToResult(value)
        didNavigate = true
      } catch {
        this.setZipError(true)
        this.zipInput.focus()
      } finally {
        if (!didNavigate) {
          this.isSearching = false
          if (this.searchButton) {
            this.searchButton.disabled = false
            this.searchButton.classList.remove('loading')
          }
        }
      }
    }

    navigateToResult(zipCode) {
      const { resultUrl = window.location.href } = this.dataset
      const url = new URL(resultUrl, window.location.origin)
      url.searchParams.set('zip', zipCode)

      const current = new URL(window.location.href)
      if (url.origin === current.origin && url.pathname === current.pathname) {
        window.history.pushState({}, '', url)
        document.documentElement.classList.add('ewg-has-zip')
        document.querySelector('.ewg-report-enter-section')?.classList.add('hidden')
        document.querySelectorAll('.ewg-report-result-section').forEach(section => {
          section.classList.remove('hidden')
        })
        document.querySelector('.cc-home-collection')?.classList.remove('hidden')
        document.querySelector('.recommend-blog-section')?.classList.remove('hidden')
        document.querySelector('.home-best-sellers')?.classList.remove('hidden')
        window.scrollTo(0, 0)
        window.WDEwgReportStore?.init()
        return
      }

      window.location.href = url.toString()
    }
  }

  customElements.define('ewg-report-enter', EWGReportEnter)
})()
